import styles from './style.module.scss';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/Button';
import MotionWrapper from '../../../../layouts/MotionWrapper';

export default function UseSignInForm() {
    const navigate = useNavigate();

    const navigateToSignIn = () => {
        navigate('/signin')
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <span className={styles.title}>
                Your Email is verified successfully <br />
                Please use our sign in form to access your dashboard
            </span>
            <Button
                type='Primary'
                className={styles.CTA}
                text='Navigate to sign in'
                onClick={navigateToSignIn}
            />
        </MotionWrapper>
    )
};
